import React from "react";
import PropTypes from "prop-types";
import { Collapse, Typography } from "antd";
import RenderFields from "./RenderFields";
const { Panel } = Collapse;
const { Text } = Typography;

export default function AdvancedParameters({
  expandAdvancePara,
  onClickExpand,
  expandSubgroup,
  onChangeSubgroup,
  formData,
  molecularScaffoldAdvance,
  learningRelatedAdvance,
  contraintsAdvance,
  displayField,
  handleInputChange,
  handleSlider,
  handleSigmoidValue,
  setFormData,
  projectId,
  isReTriggerMode,
}) {

  const mainPanelHeaderStyle = {
    backgroundColor: "#003A6C",
    fontWeight: "bold",
  };


  const mainCollapseStyle = {
    backgroundColor: "transparent",
    border: "none",
    marginBottom: "12px"
  };
  const subCollapseStyle = {
    border: "none",
    backgroundColor: "#fafafa", // Light background for sub-panels
    marginBottom: "8px" // Add some space between sub-collapses
  };

  const handleMainCollapseChange = (activeKey) => {
    if (onClickExpand) onClickExpand();
  };

  const handleSubgroupChange = (key) => {
    const newActiveKey = Array.isArray(key) ? key[key.length - 1] : key;
    onChangeSubgroup(newActiveKey || false);
  };


  return (
    <Collapse
      activeKey={expandAdvancePara ? ["advancedParamsPanel"] : []}
      onChange={handleMainCollapseChange}
      style={mainCollapseStyle}
      bordered={false}
      expandIconPosition="end"
    >
      <Panel
        header={<Text style={{ color: "white", fontWeight: "bold" }}>Advanced Parameters</Text>}
        key="advancedParamsPanel"
        style={mainPanelHeaderStyle}
      >
        <div style={{ padding: "16px", background: "#fff", color: "#000", borderRadius: "0 0 4px 4px" }}>

          <Collapse
            activeKey={expandSubgroup === "learning" ? "learningPanel" : undefined}
            onChange={() => handleSubgroupChange("learning")}
            style={subCollapseStyle}
            bordered={false}
            expandIconPosition="end"
          >
            <Panel
              header={<Text style={{ fontWeight: "bold" }}>Learning Related</Text>}
              key="learningPanel"
            >
              <div style={{ padding: "16px 0 0 0" }}>
                <RenderFields
                  fields={learningRelatedAdvance}
                  formData={formData}
                  displayField={displayField}
                  handleInputChange={handleInputChange}
                  handleSlider={handleSlider}
                  handleSigmoidValue={handleSigmoidValue}
                  projectId={projectId}
                  isReTriggerMode={isReTriggerMode}
                />
              </div>
            </Panel>
          </Collapse>

          <Collapse
            activeKey={expandSubgroup === "constraints" ? "constraintsPanel" : undefined}
            onChange={() => handleSubgroupChange("constraints")}
            style={subCollapseStyle}
            bordered={false}
            expandIconPosition="end"
          >
            <Panel
              header={<Text style={{ fontWeight: "bold" }}>Constraints</Text>}
              key="constraintsPanel"
            >
              <div style={{ padding: "16px 0 0 0" }}>
                <RenderFields
                  fields={contraintsAdvance}
                  formData={formData}
                  displayField={displayField}
                  handleInputChange={handleInputChange}
                  handleSlider={handleSlider}
                  handleSigmoidValue={handleSigmoidValue}
                  projectId={projectId}
                  isReTriggerMode={isReTriggerMode}
                />
              </div>
            </Panel>
          </Collapse>
        </div>
      </Panel>
    </Collapse>
  );
}

AdvancedParameters.propTypes = {
  expandAdvancePara: PropTypes.bool.isRequired,
  onClickExpand: PropTypes.func.isRequired,
  expandSubgroup: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onChangeSubgroup: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  molecularScaffoldAdvance: PropTypes.array.isRequired,
  learningRelatedAdvance: PropTypes.array.isRequired,
  contraintsAdvance: PropTypes.array.isRequired,
  displayField: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSlider: PropTypes.func.isRequired,
  handleSigmoidValue: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired,
  isReTriggerMode: PropTypes.bool,
};
